import React, { useState } from 'react'

const EditExpense = props => {
  const [desc, setDesc] = useState(props.desc)
  const [amount, setAmount] = useState(props.amount)

  const handleExpenseSubmited = e => {
    e.preventDefault()
    props.handleExpenseSubmit(desc, amount)
  }

  return (
    <form className='edit-expense font125 mr ml' onSubmit={handleExpenseSubmited}>
      <label htmlFor='edit-desc'>Description: </label>
      <input
        id='edit-desc'
        className='font75 text-center mb'
        type='text'
        value={desc}
        onChange={e => setDesc(e.target.value)}
      />
      <label htmlFor='edit-amount'>Amount: </label>
      <input
        id='edit-amount'
        className='font75 text-center mb'
        type='text'
        value={amount}
        onChange={e => setAmount(e.target.value)}
      />
      <input className='button-1 font75 mt mb' type='submit' value='Submit' />
    </form>
  )
}

export default EditExpense
